module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./RankView.js"));
	}, "RankView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RankView!./src/pages/Learn/My/Rank/RankView.js
// module id = 1237
// module chunks = 431